import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface NavMenuState {
    title: string,
    isDirtyForm: boolean
}

const initialState: NavMenuState = {
  title: '',
  isDirtyForm: false
};

export const NavMenuSlice = createSlice({
  name: 'navMenu',
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setDirtyForm: (state, action: PayloadAction<boolean>) => {
      state.isDirtyForm = action.payload;
    }
  }
});

export const {
  setTitle,
  setDirtyForm
} = NavMenuSlice.actions;

export default NavMenuSlice.reducer;
